import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../utils/store/AllReducers";

const ProtectedRoute = () => {
    const { userLogin } = useSelector((state: RootState) => state.auth);
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const idFromUrl = queryParams.get("id");
    const loggedBy = queryParams.get("isAkos");
    const isSSOLogin = (idFromUrl && loggedBy) ? true : false
    
    return (userLogin || isSSOLogin) ? <Outlet /> : <Navigate to="/login" replace />;
};

export default ProtectedRoute;
